import styled from "@emotion/styled";
import Button from "@mui/material/Button";

export const SetPageButton = styled(Button)`
	color: inherit;
	border-color: #a9a9a9;
	height: 40px;
	align-self: center;
	font-weight: bold;
`;

export const DivDocument = styled.div`
	width: 800px;
	-webkit-box-shadow: 0px 0px 5px -1px rgba(0, 0, 0, 0.75);
	-moz-box-shadow: 0px 0px 5px -1px rgba(0, 0, 0, 0.75);
	box-shadow: 0px 0px 5px -1px rgba(0, 0, 0, 0.75);
`;
